export function FreezeUI(options) {
    /** 
    * Freezes the UI
    * options = { 
    *   selector: '.class-name' -> Choose an element where to limit the freeze or leave empty to freeze the whole body. Make sure the element has position relative or absolute,
    *   text: 'Magic is happening' -> Choose any text to show or use the default "Loading". Be careful for long text as it will break the design.
    * }
    */



    // ** Element declaration 
    let freezeHtml = document.createElement('div');
    freezeHtml.classList.add('freeze-ui');
    freezeHtml.innerHTML = '<div class="lds-grid-spinner-wrapper">' +
        '<div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>'
        + '<h2 class="text-primary brand-text mb-0">Labosome</h2>' +
        '</div>';

    /**
     * Select Element
     **/

    let parent = options ? document.querySelector(options.selector) : document.body;

    /**
     * Set attributes for loading
     **/

    freezeHtml.setAttribute('data-text', options ? options.text : 'Loading');
    if (options) {
        if (document.querySelector(options.selector != 'body')) {
            freezeHtml.style.position = 'absolute';
        }
    }


    /** Append element to DOM  -  Freeze the UI
     * 1) First check if it is already freeze --> no need to append element
     **/

    let loaderElement = document.querySelector('.freeze-ui');
    // if (loaderElement) {
    //     loaderElement.remove()
    //     parent.appendChild(freezeHtml);
    // } else {
    //     parent.appendChild(freezeHtml);
    // }
    // if (!loaderElement) {
    parent.appendChild(freezeHtml);
    // }
}

export function UnfreezeUI() {

    /**
     * Unfreezes the UI.
     * No options here.
     **/

    let element = document.querySelector('.freeze-ui');
    if (element) {
        element.remove()
        element.classList.add('is-unfreezing');
        setTimeout(() => {
            if (element) {
                element.classList.remove('is-unfreezing');
                if (element.parentElement) {
                    element.parentElement.removeChild(element);
                }
            }
        }, 250);
    }
}
